import { FileItem } from 'ng2-file-upload';
import { ClearanceItemService } from '../clearance-item.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalService } from '../../shared/helper-components/modal/_services/modal.service';
import { Subject } from 'rxjs/Subject';
import { CIAsset } from '../clearance-item.model';
import { IAssetProcessing } from "./asset-processing.interface";
import { AppService } from "../../app.service";
import { IAsset } from './asset.interface';

@Injectable()
export class AssetImageProcessing implements IAssetProcessing {

    private _downloadStarted = new Subject<any>();
    private _downloadFinished = new Subject<any>();
    onDownloadStarted = this._downloadStarted.asObservable();
    onDownloadFinished = this._downloadFinished.asObservable();

    assetType(): string {
        return 'image';
    }

    supportedImages: string[] = ['image/png', 'image/jpeg', 'image/jpg', 'image/bmp', 'jpeg','jpg','png', 'bmp'];
    
    constructor(
        private modalService: ModalService,
        private _appService: AppService,
        private sanitizer: DomSanitizer) {
    }

    getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
      }

    downloadAsset(asset: CIAsset, projectId: string, ownerType: string, direct: boolean, tryViewInBrowser: boolean = false) {
        this._downloadStarted.next(direct);
        
        this._appService.getSignedUrl(encodeURIComponent(asset.url), projectId, 'GET', 'image', ownerType, encodeURIComponent(asset.name))
            .subscribe(signedUrl => {
                
                console.log('ImageProcessing.downloadAsset >> signed Url:' + signedUrl.url);
                let downloadedAsset = Object.assign(new CIAsset(), asset);
                downloadedAsset.fullUrl = signedUrl.url;
                downloadedAsset.name = asset.name;
                this._downloadFinished.next({asset: downloadedAsset, direct: direct});
            });
    }

    processAsset(fileItem: FileItem, projectId: string, owwerType: string): Observable<CIAsset> {
        if (!this.supportedImages.find(f=> f === fileItem.file.type)){
            return this._appService.getSignedUrl(encodeURIComponent(fileItem.file.name), projectId, 'PUT', 'image', owwerType,'')
            .map(signedUrl => {
                console.log('ImageProcessing.processAsset >> signed Url:' + signedUrl.url);

                let file = fileItem.file;

                let newAsset = new CIAsset();
                newAsset.name = file.name;
                newAsset.urlName = signedUrl.name;
                newAsset.id = signedUrl.name;
                // newAsset.fullUrl = thumbNail
                newAsset.fileType = (file.type === "" ? "application/octet-stream" : file.type);

                //prepare the file to upload
                fileItem.file.name = signedUrl.name;  //set the signed name to the just-added file
                fileItem.url = signedUrl.url.toString()
                fileItem.method = "PUT";

               return newAsset;
            });
        }
        
        var reader = new FileReader();

        var thumbNail: string = '';

        return Observable.create(observer => {

            reader.addEventListener("load", (event: any) => {
                var img = new Image();

                //let's wait until the image is fully loaded onto the DOM object
                img.addEventListener("load", (event: any) => {
                
                    //resize the image
                    thumbNail = this.createThumbnail(img, 64, fileItem.file.type);
                    var originalSizeImage = this.createThumbnail(img, Math.max(img.height, img.width), fileItem.file.type);
                    
                    //get the signed url to upload to aws
                    this._appService.getSignedUrl(encodeURIComponent(fileItem.file.name), projectId, 'PUT', 'image', owwerType,'')
                        .subscribe(signedUrl => {
                            console.log('ImageProcessing.processAsset >> signed Url:' + signedUrl.url);

                            let file = fileItem.file;

                            let newAsset = new CIAsset();
                            newAsset.name = file.name;
                            newAsset.urlName = signedUrl.name;
                            newAsset.id = signedUrl.name;
                            newAsset.fullUrl = thumbNail;
                            newAsset.originalImageFullUrl = originalSizeImage;
                            newAsset.fileType = file.type;

                            //prepare the file to upload
                            fileItem.file.name = signedUrl.name;  //set the signed name to the just-added file
                            fileItem.url = signedUrl.url.toString()
                            fileItem.method = "PUT";

                            //notify the listeners that this asset has been added to the loader queue
                            observer.next(newAsset);
                            observer.complete();
                        });

                });

                img.src = event.target.result;

            });
            
            reader.readAsDataURL(fileItem._file);
        });
    }

    createThumbnail(img: any, MAX_Pixel: number = 64, imageType: string = 'image/jpeg') {        
        var canvas = document.createElement("canvas");
        var width = img.width;
        var height = img.height;
        var factor: number;
        if (width > height) {
            factor = MAX_Pixel / width;
        } else {
            factor = MAX_Pixel / height;
        }

        canvas.width = width * factor;
        canvas.height = height * factor;
        var ctx = canvas.getContext("2d");

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        var dataUrl = canvas.toDataURL(imageType);
        return dataUrl;
    }
}




// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/asset-management/asset-image-processing.service.ts